<template>
  <div>
    <PageTitle title="Hacker News: Job" />
    <PostList source="https://hacker-news.firebaseio.com/v0/jobstories.json"/>
  </div>
</template>

<script>
import PostList from '@/components/PostList'
import PageTitle from '@/components/PageTitle'
export default {
  name: 'Job',
  components: {
    PageTitle,
    PostList
  }
}
</script>
